import type { GtmInstance, GtmTrackEventParams } from "../types";

export const useGtm = (): GtmInstance => {
  const { $gtm } = useNuxtApp();

  // During SSR, always return a mock instance to prevent warnings
  if (import.meta.server) {
    return {
      trackEvent: () => {},
      trackView: () => {},
      enable: () => {},
      disable: () => {},
      dataLayer: () => [],
      isEnabled: () => false,
    };
  }

  if (!$gtm) {
    console.warn(
      "GTM plugin is not available. Make sure the GTM layer is properly configured.",
    );
    // Return a mock GTM instance to prevent errors
    return {
      trackEvent: () => {},
      trackView: () => {},
      enable: () => {},
      disable: () => {},
      dataLayer: () => [],
      isEnabled: () => false,
    };
  }

  const instance = $gtm as GtmInstance;

  // Wrap methods to ensure they only execute when GTM tracking is enabled
  const safeTrackEvent: GtmInstance["trackEvent"] = (params) => {
    if (instance.isEnabled && !instance.isEnabled()) return;
    instance.trackEvent(params);
  };

  const safeTrackView: GtmInstance["trackView"] = (
    screenName,
    path,
    additionalEventData,
  ) => {
    if (instance.isEnabled && !instance.isEnabled()) return;
    instance.trackView(screenName, path, additionalEventData);
  };

  return {
    ...instance,
    trackEvent: safeTrackEvent,
    trackView: safeTrackView,
  };
};
